import React, { useState } from 'react';
import ModalAprimoramento from '../ModalAprimoramento/ModalAprimoramento';

import Arrow from '../../../../../assets/images/drop_down.svg';

import './index.scss';

export default function SettingsCard(props) {
  const { user } = props;
  const [showOptions, setShowOptions] = useState('');
  const [typeAprimoramento, setTypeAprimoramento] = useState('');

  return (
    <>
      <div
        className="container-settings-card"
        style={{ left: props.mousePos.x - 65 }}
      >
        <div className="seta-settings-card" />
        <div
          className="settings-card-aprimoramento"
          style={{ borderBottomRightRadius: 0, borderBottomLeftRadius: 0 }}
        >
          <div
            className="container-tipo-aprimoramento"
            onMouseEnter={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? () => setShowOptions('intent')
                : ''
            }
          >
            <div
              className="circle-aprimoramento"
              style={{ background: '#00B799' }}
            />
            <div className="tipo-aprimoramento">Intenção</div>
            <div className="aprimoramento-arrow">
              {showOptions === 'intent' ? <img src={Arrow} alt="arrow" /> : ''}
            </div>
          </div>
        </div>
        <div
          className="settings-card-aprimoramento"
          style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0 }}
        >
          <div
            className="container-tipo-aprimoramento"
            onMouseEnter={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? () => setShowOptions('entity')
                : ''
            }
          >
            <div
              className="circle-aprimoramento"
              style={{ background: '#FF770D' }}
            />
            <div className="tipo-aprimoramento">Entidade</div>
            <div className="aprimoramento-arrow">
              {showOptions === 'entity' ? <img src={Arrow} alt="arrow" /> : ''}
            </div>
          </div>
        </div>
      </div>
      {showOptions && (
        <div
          className="container-opcoes-aprimoramento"
          style={{ left: props.mousePos.x + 60 }}
          onMouseLeave={
            user?.selectedCompany?.claim?.name !== 'Viewer'
              ? () => setShowOptions('')
              : ''
          }
        >
          <div
            className="opcoes-aprimoramento"
            onClick={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? () => setTypeAprimoramento('existente')
                : ''
            }
          >
            existente
          </div>
          <div
            className="opcoes-aprimoramento"
            onClick={
              user?.selectedCompany?.claim?.name !== 'Viewer'
                ? () => setTypeAprimoramento('nova')
                : ''
            }
          >
            nova
          </div>
        </div>
      )}
      {typeAprimoramento && (
        <ModalAprimoramento
          user={user}
          setTypeAprimoramento={setTypeAprimoramento}
          typeAprimoramento={typeAprimoramento}
          showOptions={showOptions}
          selectedPart={props.selectedPart}
          setSelectedPart={props.setSelectedPart}
        />
      )}
    </>
  );
}
